import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private messageService: MessageService) {}

  info(message: string) {
    this.messageService.add({
      severity: 'info',
      detail: message,
    });
  }

  success(message: string) {
    this.messageService.add({
      severity: 'success',
      detail: message,
    });
  }

  error(message: string) {
    this.messageService.add({
      severity: 'error',
      detail: message,
    });
  }

  httpError(error: HttpErrorResponse) {
    if (error.error.payload?.content && Object.keys(error.error.payload.content).length > 0) {
      Object.entries(error.error.payload.content).forEach(([key, value]: any) => {
        this.error(value);
      });
    } else {
      this.error(error.error.message || error.message);
    }
  }
}
